import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ControllerSelect from '../../SharedComponents/formComponents/baseFormComponents/ControllerSelect';
import Arrow from '../assets/icons/Arrow';
import apiPublic from '../../../apiPublic';


const StepOne = ({ data, onChange, onNext }) => {
  const { control, getValues, setValue } = useForm({
    defaultValues: {
      marka: data?.marka || '',
      model: data?.model || '',
    },
  });

  const [error, setError] = useState('');
  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);
  const [fetchError, setFetchError] = useState('');
  const [selectedMarka, setSelectedMarka] = useState('');

  useEffect(() => {
    const fetchMakes = async () => {
      try {
        const response = await apiPublic.get('/onboarding/makes');
        setMakes(response.data);
      } catch (err) {
        setFetchError('Greška pri učitavanju marki vozila.');
      }
    };
    fetchMakes();
  }, []);

  useEffect(() => {
    if (!selectedMarka) return;
    const fetchModels = async () => {
      try {
        const response = await apiPublic.get(`/onboarding/makemodels/${selectedMarka}`);
        setModels(response.data);
      } catch (err) {
        setFetchError('Greška pri učitavanju modela.');
      }
    };
    fetchModels();
  }, [selectedMarka]);

  const handleNext = () => {
    const marka = getValues('marka');
    const model = getValues('model');
    if (!marka || !model) {
      setError('Oba polja su obavezna!');
      return;
    }
    setError('');
    onNext({ marka, model });
  };

  const handleChange = (name, value) => {
    setValue(name, value);
    onChange({ target: { name, value } });
  };

  return (
    <div style={styles.form}>
      <h2 style={styles.title}>Unesi marku i model automobila za koji tražiš deo</h2>
      <p style={styles.subtitle}>U tri koraka do traženog dela! Ispobaj Smart Part i uveri se u njegovu efikasnost</p>

      <div style={styles.inputGroup}>
        {fetchError ? (
          <p style={styles.error}>{fetchError}</p>
        ) : (
          <ControllerSelect
            name="marka"
            control={control}
            defaultValue={data?.marka}
            options={makes}
            placeholder="Marka"
            externalOnChange={(value) => {
              handleChange('marka', value);
              setSelectedMarka(value);
            }}
            width={250}
            styleForLabel={styles.selectStyle.styleForLabel}
            styleForSelect={styles.selectStyle.styleForSelect}
          />
        )}

          <ControllerSelect
            name="model"
            control={control}
            defaultValue={data?.model}
            options={models}
            placeholder="Izaberi model"
            externalOnChange={(value) => handleChange('model', value)}
            width={250}
            styleForLabel={styles.selectStyle.styleForLabel}
            styleForSelect={styles.selectStyle.styleForSelect}
          />
        

        <button onClick={handleNext} style={styles.button}>
          Započni
          <Arrow />
        </button>
      </div>
      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

export default StepOne;

const styles = {
  form: {
    maxWidth: 800,
    margin: '0 auto',
    textAlign: 'center',
  },
  title: {
    color: '#FFFFFF',
    fontSize: '34px',
    fontWeight: 400,
    textAlign: 'center',
    lineHeight: '42px',
  },
  subtitle: {
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    marginBottom: 50,
  },
  inputGroup: {
    display: 'flex',
    gap: 12,
    justifyContent: 'center',
  },
  button: {
    padding: '12px 24px',
    backgroundColor: '#d3e205',
    fontWeight: 'bold',
    borderRadius: 6,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: '20px',
    gap: 10,
  },
  error: {
    color: 'white',
    marginTop: 20,
  },
  selectStyle: {
    styleForLabel: {
      color: 'white',
    },
    styleForSelect: {
      fontSize: '16px',
      border: '1px solid #787878',
      color: 'white',
      '& .MuiSelect-icon': {
        color: 'white',
      },
      '& .MuiMenuItem-root': {
        color: 'white',
      },
    },
  },
};
